<template>
  <ul
    v-if="showOptions"
    class="filter-options"
    v-clickAway="{
      exclude: ['exclude'],
      handler: 'closeFilterOptions',
    }"
  >
    <div class="d-flex">
      <input
        class="exclude"
        type="text"
        v-model="search"
        placeholder="Search..."
      />
      <button
        class="btn btn-primary"
        :disabled="activeFilters.length === 0"
        @click="$emit('clearFilter', value)"
      >
        Reset
      </button>
    </div>
    <li
      v-for="item in formattedData"
      :key="item"
      @click="$emit('setFilter', item, value)"
      :class="['exclude', activeFilters.includes(item) ? 'active' : '']"
    >
      {{ item }}
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    activeFilters: {
      type: Array,
      required: true,
    },
  },
  computed: {
    formattedData() {
      let data = this.options;

      if (this.value == "keepers_employees") {
        let allEmployees = []
        data.forEach(item => {
          allEmployees = allEmployees.concat(item);
        });
        data = allEmployees.map((item) => {
          if (typeof item === "object") {
            if (item.name) {
              return item.name;
            }

            return item[0];
          }

          if (item == "") {
            return undefined;
          }

          return item;
        });
      } else {
        data = data.map((item) => {
          if (typeof item === "object") {
            if (item.text) {
              return item.text;
            }

            return item[0];
          }

          if (item == "") {
            return undefined;
          }

          return item;
        });
      }

      data = data.filter((item) => {
          return item !== undefined && this.search
            ? item.toLowerCase().includes(this.search.toLowerCase())
            : true;
        });
      return [...new Set(data)];
    },
  },
  data() {
    return {
      search: "",
      showOptions: false,
    };
  },
  mounted() {
    this.$eventBus.$on(`toggleFilterOptions:${this.value}`, () => {
      this.showOptions = !this.showOptions;
    });
  },
  methods: {
    closeFilterOptions() {
      this.showOptions = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-options {
  padding: 0px;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 50px;
  text-align: left;
  list-style: none;
  max-height: 200px;
  overflow: auto;
  z-index: 10;
  background-color: #fff;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 6px 3px rgb(0 0 0 / 5%);
  min-width: 100%;

  li {
    padding: 5px 15px;

    &.active {
      background-color: #f5f5f5;
    }

    &:hover {
      background-color: #f5f5f5;
    }
  }

  input[type="text"] {
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: block;
    padding: 8px 15px;
    width: 100%;
    font-size: 100%;
    margin-bottom: 8px;
    background-color: #fff;
  }

  ::placeholder {
    font-size: 100%;
  }

  .d-flex {
    justify-content: center;
    align-items: flex-start;
    position: sticky;
    top: 0;

    .btn {
      margin: 0 !important;
      font-size: 11px !important;
      height: 100%;
      border-radius: 0 !important;
      display: block;
      padding: 10px;
    }
  }
}
</style>